import { useSelector } from "react-redux";

import {
  viEarth,
  viList,
  viLocationPinDot,
  viMegaphone,
  viMusic,
  viNumpad,
  viPeople,
  viPeopleCircle,
  viPerson,
  viRectangleP,
  viTableClock,
  viToggleOn,
  viVoicemail,
} from "@sippy-platform/valkyrie";

/**
 * A hook that echos why the component updated
 *
 * @return {function}    Returns the value and a function to change it
 */
export default function useGoTo() {
  const callParkingStore = useSelector((state) => state.domain.callParkings);
  const conferenceStore = useSelector((state) => state.domain.conferences);
  const customDestinationStore = useSelector((state) => state.domain.customDestinations);
  const dayNightStore = useSelector((state) => state.domain.dayNights);
  const groupStore = useSelector((state) => state.domain.groups);
  const intercomStore = useSelector((state) => state.domain.intercoms);
  const ivrStore = useSelector((state) => state.domain.ivrs);
  const mobileStore = useSelector((state) => state.domain.mobile);
  const queueStore = useSelector((state) => state.domain.queues);
  const soundStore = useSelector((state) => state.domain.sounds);
  const timetableStore = useSelector((state) => state.domain.timetables);
  const userStore = useSelector((state) => state.domain.users);
  const voicemailStore = useSelector((state) => state.domain.voicemails);

  function getGoTo(value) {
    let user,
      mobile,
      group,
      timetable,
      sound,
      callParking,
      voicemail,
      queue,
      ivr,
      destination,
      conference,
      intercom,
      dayNight;

    if (value?.sound) {
      sound = soundStore.list.find((item) => item.id === value.sound);
      if (sound) {
        return { type: "Sound", exten: false, name: sound.name, icon: viMusic };
      }
    } else if (value?.exten) {
      user = userStore.list.find((item) => item.exten === value.exten);
      if (user) {
        return {
          type: "User",
          exten: user.exten,
          name: user.name,
          icon: viPerson,
        };
      }

      mobile = mobileStore.list.find((item) => item.exten === value.exten);
      if (mobile) {
        return {
          type: "Mobile user",
          exten: mobile.exten,
          name: mobile.name,
          icon: viPerson,
        };
      }

      group = groupStore.list.find((item) => item.exten === value.exten);
      if (group) {
        return {
          type: "Group",
          exten: group.exten,
          name: group.name,
          icon: viPeople,
        };
      }

      timetable = timetableStore.list.find((item) => item.exten === value.exten);
      if (timetable) {
        return {
          type: "Timetable",
          exten: false,
          name: timetable.name,
          icon: viTableClock,
        };
      }

      callParking = callParkingStore.list.find((item) => item.exten === value.exten);
      if (callParking) {
        return {
          type: "Call parking",
          exten: callParking.exten,
          name: callParking.name,
          icon: viRectangleP,
        };
      }

      voicemail = voicemailStore.list.find((item) => item.exten === value.exten);
      if (voicemail) {
        return {
          type: "Voicemail",
          exten: voicemail.exten,
          name: voicemail.name,
          icon: viVoicemail,
        };
      }

      queue = queueStore.list.find((item) => item.exten === value.exten);
      if (queue) {
        return {
          type: "Queue",
          exten: queue.exten,
          name: queue.name,
          icon: viList,
        };
      }

      ivr = ivrStore.list.find((item) => item.exten === value.exten);
      if (ivr) {
        return {
          type: "IVR",
          exten: ivr.exten,
          name: ivr.name,
          icon: viNumpad,
        };
      }

      destination = customDestinationStore.list.find((item) => item.exten === value.exten);
      if (destination) {
        return {
          type: "Custom destination",
          exten: destination.exten,
          name: destination.name,
          icon: viLocationPinDot,
        };
      }

      conference = conferenceStore.list.find((item) => item.exten === value.exten);
      if (conference) {
        return {
          type: "Conference",
          exten: conference.exten,
          name: conference.name,
          icon: viPeopleCircle,
        };
      }

      intercom = intercomStore.list.find((item) => item.exten === value.exten);
      if (intercom) {
        return {
          type: "Intercom",
          exten: intercom.exten,
          name: intercom.name,
          icon: viMegaphone,
        };
      }

      dayNight = dayNightStore.list.find((item) => item.exten === value.exten);
      if (dayNight) {
        return {
          type: "Switch",
          exten: dayNight.exten,
          name: dayNight.name,
          icon: viToggleOn,
        };
      }
    } else if (value?.custom) {
      return {
        type: "Unrestricted number",
        exten: false,
        name: value.custom,
        icon: viEarth,
      };
    } else {
      return null;
    }
  }

  return { getGoTo };
}
